module.exports = __webpack_public_path__ + "static/media/1_A1_10.8fd1d1fd.png";